exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-galaxy-tsx": () => import("./../../../src/pages/galaxy.tsx" /* webpackChunkName: "component---src-pages-galaxy-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-stars-tsx": () => import("./../../../src/pages/stars.tsx" /* webpackChunkName: "component---src-pages-stars-tsx" */)
}

